'use client';

import dynamic from 'next/dynamic';
import { SectLabel, SectH2, SectLede } from '@/components/landing/v4-shared';
import { AI_BUSINESS_PAGE_COPY, V4_BRAND } from '@/lib/marketing/messaging-bank';

const FloatingVoiceV1 = dynamic(
  () => import('@/components/voice/FloatingVoiceV1'),
  { ssr: false }
);

export function VoiceWidgetSection() {
  const section = AI_BUSINESS_PAGE_COPY.sections.find((s) => s.id === 'voice-widget');
  if (!section) return null;
  return (
    <section className="py-24 md:py-32 relative">
      <div className="v4-aibp-section-rule absolute top-0 inset-x-0" aria-hidden="true" />
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-5 flex justify-center">
          <SectLabel color="var(--amber-glow)">{section.eyebrow}</SectLabel>
        </div>
        <SectH2 style={{ margin: '0 auto 24px', textAlign: 'center', maxWidth: '24ch' }}>
          {section.heading}
        </SectH2>
        <div className="mx-auto" style={{ maxWidth: '640px' }}>
          <SectLede style={{ margin: '0 auto', textAlign: 'center' }}>
            {section.body}
          </SectLede>
        </div>

        <div className="mt-10 flex justify-center" data-campaign="ai-business-page">
          <FloatingVoiceV1
            surface="ai_business_page_marketing"
            variant="centered-ring"
            postCall={{ mode: 'cta', href: V4_BRAND.postDemoCtaHref, label: 'Get started' }}
          />
        </div>
      </div>
    </section>
  );
}
